import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["disabled", "id", "name", "checked"]
const _hoisted_3 = {
  key: 0,
  class: "ml-2 text-sm"
}
const _hoisted_4 = ["for"]


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
	defaultSlot: {
		type: Boolean,
		default: true,
	},
	modelValue: {
		default: null,
		required: true,
	},
	name: {
		type: String,
		default: null,
	},
	id: {
		type: String,
	},
	label: {
		type: String,
	},
	readonly: {
		type: Boolean,
		default: false,
	},
	checked: {
		type: Boolean,
		default: false,
	},
    disabled: {
        type: Boolean,
        default: false,
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative flex items-center", __props.readonly ? 'pointer-events-none cursor-default' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        disabled: __props.disabled,
        id: __props.id,
        name: __props.name,
        checked: __props.checked,
        type: "checkbox",
        class: "w-6 h-6 border-2 border-gray-300 rounded cursor-pointer text-primary-600 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-primary-600",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.checked)))
      }, null, 40, _hoisted_2)
    ]),
    (__props.defaultSlot)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", {
            for: __props.id,
            class: "text-sm font-medium cursor-pointer text-neutral-900"
          }, _toDisplayString(__props.label), 9, _hoisted_4)
        ]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 2))
}
}

})